// import React, { useEffect, useRef, useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import emailjs from '@emailjs/browser';

// export default function Contact({ onSectionChange }) {
//   const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [isError, setIsError] = useState(false);
//   const [typingText, setTypingText] = useState('');
//   const [typingIndex, setTypingIndex] = useState(0);
//   const [typingComplete, setTypingComplete] = useState(false);
//   const [chatMessages, setChatMessages] = useState([]);
//   const [userMessage, setUserMessage] = useState('');
//   const [userEmail, setUserEmail] = useState(''); // Added for auto-reply
//   const [isChatOpen, setIsChatOpen] = useState(false);
//   const [showEmailInput, setShowEmailInput] = useState(false); // To show email input in chat
//   const formRef = useRef(null);
//   const chatContainerRef = useRef(null);
//   const canvasRef = useRef(null);

//   // Typing animation effect
//   useEffect(() => {
//     const phrases = [
//       "Let's create something amazing together",
//       "Ready to bring your ideas to life",
//       "Innovative solutions for your needs",
//       "Your vision, our expertise"
//     ];
//     const currentPhrase = phrases[typingIndex];
    
//     if (typingText.length < currentPhrase.length) {
//       const timeout = setTimeout(() => {
//         setTypingText(currentPhrase.substring(0, typingText.length + 1));
//       }, 100);
//       return () => clearTimeout(timeout);
//     } else {
//       const timeout = setTimeout(() => {
//         if (typingIndex < phrases.length - 1) {
//           setTypingIndex(prev => prev + 1);
//           setTypingText('');
//         } else {
//           setTypingComplete(true);
//         }
//       }, 2000);
//       return () => clearTimeout(timeout);
//     }
//   }, [typingText, typingIndex]);

//   // Canvas particles initialization
//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
    
//     const ctx = canvas.getContext('2d');
//     canvas.width = window.innerWidth;
//     canvas.height = window.innerHeight;
    
//     const particles = [];
//     const particleCount = Math.floor(canvas.width / 10);
    
//     // Create particles
//     for (let i = 0; i < particleCount; i++) {
//       particles.push({
//         x: Math.random() * canvas.width,
//         y: Math.random() * canvas.height,
//         radius: Math.random() * 3 + 1,
//         color: `rgba(100, 200, 255, ${Math.random() * 0.5 + 0.3})`,
//         speed: Math.random() * 0.5 + 0.1,
//         angle: Math.random() * Math.PI * 2,
//         drift: (Math.random() - 0.5) * 0.05
//       });
//     }
    
//     // Mouse interaction
//     let mouseX = 0;
//     let mouseY = 0;
//     let mouseRadius = 100;
    
//     const handleMouseMove = (e) => {
//       mouseX = e.clientX;
//       mouseY = e.clientY;
//     };
    
//     window.addEventListener('mousemove', handleMouseMove);
    
//     // Animation loop
//     let animationFrameId;
    
//     const render = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
      
//       // Draw gradient background
//       const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
//       gradient.addColorStop(0, '#0f172a');
//       gradient.addColorStop(0.5, '#1e293b');
//       gradient.addColorStop(1, '#0c0a1d');
//       ctx.fillStyle = gradient;
//       ctx.fillRect(0, 0, canvas.width, canvas.height);
      
//       // Update and draw particles
//       particles.forEach(p => {
//         // Move particle
//         p.x += Math.cos(p.angle) * p.speed;
//         p.y += Math.sin(p.angle) * p.speed;
//         p.angle += p.drift;
        
//         // Boundary check
//         if (p.x < -p.radius) p.x = canvas.width + p.radius;
//         if (p.x > canvas.width + p.radius) p.x = -p.radius;
//         if (p.y < -p.radius) p.y = canvas.height + p.radius;
//         if (p.y > canvas.height + p.radius) p.y = -p.radius;
        
//         // Mouse interaction
//         const dx = p.x - mouseX;
//         const dy = p.y - mouseY;
//         const distance = Math.sqrt(dx * dx + dy * dy);
        
//         if (distance < mouseRadius) {
//           const force = (mouseRadius - distance) / mouseRadius;
//           p.x += dx * force * 0.1;
//           p.y += dy * force * 0.1;
//         }
        
//         // Draw particle
//         ctx.beginPath();
//         ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
//         ctx.fillStyle = p.color;
//         ctx.fill();
//       });
      
//       // Connect particles
//       for (let i = 0; i < particles.length; i++) {
//         for (let j = i + 1; j < particles.length; j++) {
//           const dx = particles[i].x - particles[j].x;
//           const dy = particles[i].y - particles[j].y;
//           const distance = Math.sqrt(dx * dx + dy * dy);
          
//           if (distance < 100) {
//             ctx.beginPath();
//             ctx.strokeStyle = `rgba(100, 200, 255, ${0.2 * (1 - distance/100)})`;
//             ctx.lineWidth = 0.5;
//             ctx.moveTo(particles[i].x, particles[i].y);
//             ctx.lineTo(particles[j].x, particles[j].y);
//             ctx.stroke();
//           }
//         }
//       }
      
//       animationFrameId = requestAnimationFrame(render);
//     };
    
//     render();
    
//     // Cleanup
//     return () => {
//       cancelAnimationFrame(animationFrameId);
//       window.removeEventListener('mousemove', handleMouseMove);
//     };
//   }, []);

//   // Chat auto-scroll
//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//     }
//   }, [chatMessages]);

//   const validators = {
//     name: v => v.trim().length >= 2,
//     email: v => /^\S+@\S+\.\S+$/.test(v),
//     subject: v => v.trim().length >= 3,
//     message: v => v.trim().length >= 10
//   };

//   const handleInputChange = e => {
//     const { name, value } = e.target;
//     setFormData(s => ({ ...s, [name]: value }));
//     setErrors(s => ({ ...s, [name]: validators[name] ? !validators[name](value) : false }));
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     const newErrors = {};
//     Object.keys(validators).forEach(k => { 
//       if (!validators[k](formData[k] || '')) newErrors[k] = true 
//     });
//     setErrors(newErrors);
//     if (Object.keys(newErrors).length) return;
//     setIsSubmitting(true);
    
//     try {
//       // Using EmailJS to send the form
//       const result = await emailjs.sendForm(
//         'service_1i5nx08',
//         'template_svdxpun',
//         formRef.current, 
//         '3V99tek_1xPeoRF7I'
//       );
      
//       console.log('EmailJS Result:', result);
//       setIsSubmitting(false);
//       setIsSuccess(true);
//       setFormData({ name: '', email: '', subject: '', message: '' });
//       setTimeout(() => setIsSuccess(false), 3200);
//     } catch (error) {
//       console.error('EmailJS Error:', error);
//       setIsSubmitting(false);
//       setIsError(true);
//       setTimeout(() => setIsError(false), 3200);
//     }
//   };

//   const handleChatSubmit = e => {
//     e.preventDefault();
//     if (!userMessage.trim()) return;
    
//     // Add user message
//     const newMessages = [...chatMessages, 
//       { text: userMessage, sender: 'user', time: new Date() }
//     ];
//     setChatMessages(newMessages);
    
//     // Save the user message to send via EmailJS
//     const userMsg = userMessage;
//     setUserMessage('');
    
//     // Send auto-reply using EmailJS with template_40myx8j if email is provided
//     if (userEmail) {
//       const templateParams = {
//         from_name: 'Vivek Yadav',
//         to_email: userEmail,
//         message: userMsg,
//         auto_reply_message: `Thank you for contacting me! This is an automated response to confirm I have received your message. I will review your inquiry and get back to you within 24 hours.\n\nBest regards,\nVivek Yadav`
//       };
      
//       emailjs.send(
//         'service_1i5nx08',
//         'template_40myx8j',
//         templateParams,
//         '3V99tek_1xPeoRF7I'
//       ).then((response) => {
//         console.log('Auto-reply sent successfully!', response.status, response.text);
//       }).catch((err) => {
//         console.error('Failed to send auto-reply:', err);
//       });
//     }
    
//     // Show immediate bot response in chat
//     setTimeout(() => {
//       const responses = [
//         "Thanks for your message! I've received it and will get back to you within 24 hours.",
//         "I've received your inquiry and sent you an automatic confirmation. I'll respond personally soon!",
//         "Great question! I've noted your message and sent you an auto-confirmation. I'll get back to you shortly.",
//         "I appreciate you reaching out. You should receive an auto-confirmation email, and I'll follow up personally soon."
//       ];
//       setChatMessages(prev => [
//         ...prev, 
//         { 
//           text: responses[Math.floor(Math.random() * responses.length)], 
//           sender: 'bot', 
//           time: new Date() 
//         }
//       ]);
//     }, 1500);
//   };





//   return (
//     <div className={`min-h-screen relative overflow-hidden bg-gradient-to-b from-gray-900 via-gray-800 to-black py-12 px-4 sm:px-6 lg:px-8`}>
//       <canvas 
//         ref={canvasRef} 
//         className="absolute inset-0 w-full h-full -z-10"
//       />

//       <div className="max-w-7xl mx-auto relative z-20">
//         <Header 
//           typingText={typingText} 
//           typingComplete={typingComplete}
//         />

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start mt-12">
//           <motion.div 
//             className="lg:col-span-7" 
//             initial={{ opacity: 0, x: -40 }} 
//             animate={{ opacity: 1, x: 0 }} 
//             transition={{ duration: 0.8, delay: 0.15 }}
//           >
//             {/* Contact Form - Removed tab animation */}
//             <ContactCardForm
//               formRef={formRef}
//               formData={formData}
//               onChange={handleInputChange}
//               onSubmit={handleSubmit}
//               errors={errors}
//               isSubmitting={isSubmitting}
//               setFormData={setFormData}
//               setErrors={setErrors}
//             />

//             <Testimonials />

//           </motion.div>

//           <motion.aside 
//             className="lg:col-span-5 space-y-6" 
//             initial={{ opacity: 0, x: 40 }} 
//             animate={{ opacity: 1, x: 0 }} 
//             transition={{ duration: 0.8, delay: 0.25 }}
//           >
//             <ContactInfoPanel />
//             <QuickMap />
//           </motion.aside>
//         </div>

//         <div className="mt-8 flex items-center justify-center">
//           <motion.button 
//             onClick={() => {
//               const section = document.getElementById('about');
//               if (section) {
//                 window.scrollTo({
//                   top: section.offsetTop - 80,
//                   behavior: 'smooth'
//                 });
//               }
//             }} 
//             whileHover={{ scale: 1.04 }} 
//             whileTap={{ scale: 0.96 }} 
//             className="px-8 py-3 rounded-full font-semibold shadow-xl bg-gradient-to-r from-indigo-500 to-pink-500 text-white"
//           >
//             Back to Home
//           </motion.button>
//         </div>

//       </div>

//       <AnimatePresence>
//         {isSuccess && <SuccessToast onClose={() => setIsSuccess(false)} />}
//         {isError && <ErrorToast onClose={() => setIsError(false)} />}
//       </AnimatePresence>
      
//       <LiveChatWidget 
//         isOpen={isChatOpen} 
//         setIsOpen={setIsChatOpen}
//         messages={chatMessages}
//         userMessage={userMessage}
//         setUserMessage={setUserMessage}
//         onSubmit={handleChatSubmit}
//         chatContainerRef={chatContainerRef}
//         userEmail={userEmail}
//         setUserEmail={setUserEmail}
//         showEmailInput={showEmailInput}
//         setShowEmailInput={setShowEmailInput}
//       />

//       <Footer />
//     </div>
//   );
// }

// /* ---------------------------
//    Header with typing effect
//    --------------------------- */
// function Header({ typingText, typingComplete }) {
//   return (
//     <motion.div 
//       initial={{ opacity: 0, y: 20 }} 
//       animate={{ opacity: 1, y: 0 }} 
//       transition={{ duration: 0.8 }} 
//       className="text-center mb-12"
//     >
      
//       <h1 className="text-5xl sm:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-indigo-400 to-pink-400">
//         Get In Touch
//       </h1>
      
//       <div className="mt-4 h-16 flex items-center justify-center">
//         {typingComplete ? (
//           <motion.p 
//             initial={{ opacity: 0 }} 
//             animate={{ opacity: 1 }} 
//             className="text-lg max-w-3xl mx-auto"
//           >
//             Ready to collaborate? Tell me about your project and I'll get back to you.
//           </motion.p>
//         ) : (
//           <p className="text-lg max-w-3xl mx-auto h-6">
//             {typingText}
//             <motion.span 
//               animate={{ opacity: [0, 1, 0] }} 
//               transition={{ repeat: Infinity, duration: 1 }} 
//               className="ml-1"
//             >
//               |
//             </motion.span>
//           </p>
//         )}
//       </div>
//     </motion.div>
//   );
// }



// /* ---------------------------
//    Contact Form Card
//    --------------------------- */
// function ContactCardForm({ formRef, formData, onChange, onSubmit, errors, isSubmitting, setFormData, setErrors }) {
//   return (
//     <div className="p-8 rounded-2xl backdrop-blur-lg border bg-gradient-to-br from-gray-900/60 via-gray-800/40 to-gray-900/50 border-gray-700/60">
//       <h2 className="text-2xl font-bold mb-6">Send a message</h2>

//       <form ref={formRef} onSubmit={onSubmit} className="space-y-6">
//         <FloatingInput 
//           name="name" 
//           value={formData.name} 
//           onChange={onChange} 
//           placeholder="Name" 
//           error={errors.name}
//         />
//         <FloatingInput 
//           name="email" 
//           type="email" 
//           value={formData.email} 
//           onChange={onChange} 
//           placeholder="Email" 
//           error={errors.email}
//         />
//         <FloatingInput 
//           name="subject" 
//           value={formData.subject} 
//           onChange={onChange} 
//           placeholder="Subject" 
//           error={errors.subject}
//         />
//         <FloatingTextarea 
//           name="message" 
//           value={formData.message} 
//           onChange={onChange} 
//           placeholder="Your message" 
//           error={errors.message}
//         />

//         <div className="flex items-center gap-4">
//           <motion.button 
//             whileHover={{ scale: 1.02 }} 
//             whileTap={{ scale: 0.98 }} 
//             type="submit" 
//             disabled={isSubmitting} 
//             className="flex-1 inline-flex items-center justify-center gap-3 rounded-lg py-3 px-5 font-semibold shadow-lg hover:brightness-110 transition-all bg-gradient-to-r from-cyan-400 to-indigo-500 text-black"
//           >
//             {isSubmitting ? <Spinner /> : <SendIcon />}
//             <span>{isSubmitting ? 'Sending...' : 'Send Message'}</span>
//           </motion.button>

//           <motion.button 
//             whileHover={{ scale: 1.02 }} 
//             whileTap={{ scale: 0.98 }} 
//             type="button" 
//             onClick={() => { setFormData({ name: '', email: '', subject: '', message: '' }); setErrors({}); }} 
//             className="px-4 py-3 rounded-lg border bg-gray-800 border-gray-700 text-gray-200 hover:bg-gray-700"
//           >
//             Reset
//           </motion.button>
//         </div>


//       </form>
//     </div>
//   );
// }

// /* ---------------------------
//    Live Chat Widget
//    --------------------------- */
// function LiveChatWidget({ isOpen, setIsOpen, messages, userMessage, setUserMessage, onSubmit, chatContainerRef, userEmail, setUserEmail, showEmailInput, setShowEmailInput }) {
//   return (
//     <>
//       {/* Removed the floating chat button */}
      
//       <AnimatePresence>
//         {isOpen && (
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8, y: 20 }}
//             animate={{ opacity: 1, scale: 1, y: 0 }}
//             exit={{ opacity: 0, scale: 0.8, y: 20 }}
//             className="fixed bottom-24 right-6 z-50 w-full max-w-md rounded-2xl shadow-xl overflow-hidden bg-gray-800"
//           >
//             <div className="p-4 flex justify-between items-center bg-gray-900">
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-gradient-to-r from-cyan-400 to-indigo-500 flex items-center justify-center">
//                   <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                 </div>
//                 <div>
//                   <div className="font-semibold text-white">Support Team</div>
//                   <div className="text-xs text-cyan-200">Online now</div>
//                 </div>
//               </div>
//               <button 
//                 onClick={() => setIsOpen(false)}
//                 className="text-gray-300 hover:text-white"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
            
//             <div 
//               ref={chatContainerRef}
//               className="h-80 overflow-y-auto p-4 space-y-4 bg-gray-800"
//             >
//               {messages.length === 0 ? (
//                 <div className="h-full flex flex-col items-center justify-center text-center p-4">
//                   <div className="mb-4">
//                     <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-r from-cyan-400 to-indigo-500 flex items-center justify-center">
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
//                       </svg>
//                     </div>
//                   </div>
//                   <h3 className="font-bold text-lg mb-2">How can we help you?</h3>
//                   <p className="text-gray-500">Send us a message and we'll get back to you as soon as possible.</p>
//                 </div>
//               ) : (
//                 messages.map((msg, index) => (
//                   <div 
//                     key={index} 
//                     className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
//                   >
//                     <div 
//                       className={`max-w-xs rounded-2xl px-4 py-2 ${msg.sender === 'user' 
//                         ? 'bg-cyan-500' 
//                         : 'bg-gray-700'}`}
//                     >
//                       {msg.text}
//                       <div className={`text-xs mt-1 ${msg.sender === 'user' ? 'text-cyan-100' : 'text-gray-400'}`}>
//                         {msg.time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>
            
//             <form onSubmit={onSubmit} className="p-3 border-t bg-gray-900 border-gray-700">
//               {showEmailInput && (
//                 <div className="mb-2">
//                   <input
//                     type="email"
//                     value={userEmail}
//                     onChange={(e) => setUserEmail(e.target.value)}
//                     placeholder="Your email for auto-reply..."
//                     className="w-full rounded-full px-4 py-2 bg-gray-800 text-white text-sm"
//                   />
//                 </div>
//               )}
//               <div className="flex gap-2">
//                 <input
//                   type="text"
//                   value={userMessage}
//                   onChange={(e) => setUserMessage(e.target.value)}
//                   placeholder="Type your message..."
//                   className="flex-1 rounded-full px-4 py-2 bg-gray-800 text-white"
//                 />
//                 <button 
//                   type="submit"
//                   className="w-10 h-10 rounded-full flex items-center justify-center bg-cyan-500"
//                 >
//                   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
//                   </svg>
//                 </button>
//               </div>
//               {!showEmailInput && (
//                 <div className="mt-2 text-right">
//                   <button
//                     type="button"
//                     onClick={() => setShowEmailInput(true)}
//                     className="text-xs text-cyan-300 hover:text-cyan-200"
//                   >
//                     Add email for auto-reply
//                   </button>
//                 </div>
//               )}
//             </form>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// }

// /* ---------------------------
//    Form inputs (Floating)
//    --------------------------- */
// function FloatingInput({ name, value, onChange, placeholder, error, type = 'text' }) {
//   return (
//     <div className={`relative`}> 
//       <input 
//         name={name} 
//         type={type} 
//         value={value} 
//         onChange={onChange} 
//         placeholder={placeholder} 
//         className={`peer w-full rounded-xl px-4 py-3 focus:outline-none focus:ring-2 transition ${
//           `bg-gray-800 border ${error ? 'border-red-500' : 'border-gray-700'} text-white placeholder-transparent focus:ring-cyan-400`}`} 
//       />
//       <label className={`absolute left-4 top-2 text-sm transition-all pointer-events-none text-gray-400 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:text-sm peer-focus:top-2 peer-focus:text-cyan-400 ${value ? 'hidden' : 'block'}`}
//       >
//         {placeholder}
//       </label>
//       <div className={`mt-2 text-xs ${error ? 'text-red-500' : 'text-gray-400'}`}>
//         {error ? 'Please provide a valid value' : '\u00A0'}
//       </div>
//     </div>
//   );
// }

// function FloatingTextarea({ name, value, onChange, placeholder, error }) {
//   return (
//     <div className="relative"> 
//       <textarea 
//         name={name} 
//         value={value} 
//         onChange={onChange} 
//         placeholder={placeholder} 
//         rows={6} 
//         className={`peer w-full rounded-xl px-4 py-3 focus:outline-none focus:ring-2 transition resize-none ${
//           `bg-gray-800 border ${error ? 'border-red-500' : 'border-gray-700'} text-white placeholder-transparent focus:ring-cyan-400`}`} 
//       />
//       <label className={`absolute left-4 top-2 text-sm transition-all pointer-events-none text-gray-400 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:text-sm peer-focus:top-2 peer-focus:text-cyan-400 ${value ? 'hidden' : 'block'}`}
//       >
//         {placeholder}
//       </label>
//       <div className={`mt-2 text-xs ${error ? 'text-red-500' : 'text-gray-400'}`}>
//         {error ? 'Message must be at least 10 characters' : '\u00A0'}
//       </div>
//     </div>
//   );
// }

// /* ---------------------------
//    Spinner & Icons
//    --------------------------- */
// function Spinner() {
//   return (
//     <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none">
//       <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.2)" strokeWidth="4" />
//       <path d="M4 12a8 8 0 018-8" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
//     </svg>
//   );
// }

// function SendIcon() {
//   return (
//     <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
//       <path d="M2 21l21-9L2 3v7l15 2-15 2v7z" fill="#000" />
//     </svg>
//   );
// }


// /* ---------------------------
//    Testimonials
//    --------------------------- */
// function Testimonials() {
//   const data = [
//     { name: 'Raman', role: 'Student', quote: 'Every scroll feels intentional. Every click feels rewarding.' },
//     { name: 'Simarpreet', role: 'Frontend Developer', quote: 'Clean UI — this site is basically a React symphony.' },
//     { name: 'Nikhil', role: 'ML&AI Engineer', quote: 'Bro that Animation... Wow! I love it!' },
//     { name: 'San', role: 'Engineer', quote: 'Definitely the best website I have ever encountered.' }
//   ];
  
//   return (
//     <div className="mt-6 space-y-4">
//       <h3 className="font-semibold mb-2 text-white">What people say</h3>
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//         {data.map((t, i) => (
//           <motion.div 
//             key={i} 
//             initial={{ opacity: 0, y: 10 }} 
//             animate={{ opacity: 1, y: 0 }} 
//             transition={{ delay: 0.1 + i * 0.08 }} 
//             className="p-4 rounded-lg bg-gray-800/30 border-gray-700/30"
//           >
//             <div className="text-gray-200">"{t.quote}"</div>
//             <div className="mt-3 text-sm text-gray-400">
//               — {t.name}, <span className="text-gray-300">{t.role}</span>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ---------------------------
//    Contact info panel
//    --------------------------- */
// function ContactInfoPanel() {
//   return (
//     <div className="p-6 rounded-2xl backdrop-blur-sm border bg-gradient-to-br from-gray-800/60 to-gray-900/40 border-gray-700/60">
//       <h2 className="text-2xl font-bold mb-4 text-white">Contact Info</h2>

//       <div className="space-y-4">
//         <ContactCard 
//           title="Email" 
//           subtitle="vivekkuyadav21@gmail.com" 
//           icon={<MailIcon />}
//         />
//         <ContactCard 
//           title="Location" 
//           subtitle="Lovely Professional University (LPU), Jalandhar-Delhi G.T. Road, Phagwara, Punjab, India - 144411" 
//           icon={<LocationIcon />}
//         />
//       </div>

//       <div className="mt-6">
//         <h3 className="font-semibold mb-3 text-white">Connect</h3>
//         <SocialGrid />
//       </div>
//     </div>
//   );
// }

// /* ---------------------------
//    Quick Map
//    --------------------------- */
// function QuickMap() {
//   return (
//     <div className="p-6 rounded-2xl backdrop-blur-sm border bg-gradient-to-br from-gray-800/40 to-gray-900/20 border-gray-700/40">
//       <h3 className="font-semibold mb-3 text-white">Quick Map</h3>
//       <div className="w-full h-44 rounded-lg overflow-hidden border">
//         <iframe 
//           title="map" 
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3423.297054450433!2d75.70487037532045!3d31.25417987433384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5a5b2bdb287d%3A0x6890235e8d1dc490!2sLovely%20Professional%20University!5e0!3m2!1sen!2sin!4v1691760000000" 
//           className="w-full h-full" 
//           loading="lazy"
//         ></iframe>
//       </div>

//       <div className="mt-4 grid grid-cols-2 gap-3">
//         <MiniStat label="Avg response" value="1-2 days" />
//         <MiniStat label="Projects" value="30+" />
//         <MiniStat label="Experience" value="5 yrs" />
//         <MiniStat label="Availability" value="Part-time" />
//       </div>
//     </div>
//   );
// }


// /* ---------------------------
//    Mini stat & funfact
//    --------------------------- */
// function MiniStat({ label, value }) {
//   return (
//     <div className="p-3 rounded-lg text-center bg-gray-800/30 border-gray-700/30">
//       <div className="text-sm text-gray-400">{label}</div>
//       <div className="text-lg font-semibold text-white">{value}</div>
//     </div>
//   );
// }

// /* ---------------------------
//    Contact card small
//    --------------------------- */
// function ContactCard({ title, subtitle, icon }) {
//   return (
//     <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-700/20 border-gray-700/30">
//       <div className="w-12 h-12 rounded-md flex items-center justify-center bg-gradient-to-br from-cyan-400/10 to-indigo-500/10">
//         {icon}
//       </div>
//       <div>
//         <div className="text-sm font-medium text-gray-300">{title}</div>
//         <div className="text-sm text-gray-400">{subtitle}</div>
//       </div>
//     </div>
//   );
// }

// /* ---------------------------
//    Social grid
//    --------------------------- */
// function SocialGrid() {
//   const socials = [
//     { name: 'GitHub', icon: <GitHubIcon />, url: 'https://github.com/V1VEK-Y4DAV' },
//     { name: 'LinkedIn', icon: <LinkedInIcon />, url: 'https://www.linkedin.com/in/v1vek-y4dav/' },
//     { name: 'Twitter', icon: <TwitterIcon />, url: 'https://x.com/VIVEKxxi' },
//     { name: 'LeetCode', icon: <LeetCodeIcon />, url: 'https://leetcode.com/u/V1VEK_/' }
//   ];
  
//   return (
//     <div className="grid grid-cols-2 gap-3">
//       {socials.map((s, i) => (
//         <motion.a 
//           key={s.name} 
//           href={s.url} 
//           target="_blank" 
//           rel="noreferrer" 
//           whileHover={{ y: -4 }} 
//           className="flex items-center gap-3 p-3 rounded-lg bg-gray-800/60 border border-gray-600 hover:bg-gray-700/70 hover:border-cyan-400/50 transition-all duration-300 shadow-md hover:shadow-lg"
//         >
//           <div className="w-8 h-8 rounded-md flex items-center justify-center bg-gray-800/50">
//             {s.icon}
//           </div>
//           <div className="text-sm font-medium text-gray-100">
//             {s.name}
//           </div>
//         </motion.a>
//       ))}
//     </div>
//   );
// }

// /* ---------------------------
//    Footer and Success toast
//    --------------------------- */
// function SuccessToast({ onClose }) {
//   useEffect(() => { const id = setTimeout(onClose, 3000); return () => clearTimeout(id); }, [onClose]);
  
//   return (
//     <motion.div 
//       initial={{ opacity: 0, y: 20 }} 
//       animate={{ opacity: 1, y: 0 }} 
//       exit={{ opacity: 0, y: 20 }} 
//       transition={{ duration: 0.4 }} 
//       className="fixed right-6 bottom-6 z-50"
//     >
//       <div className="px-5 py-3 rounded-xl bg-gradient-to-r from-green-400 to-cyan-300 text-black shadow-lg flex items-center gap-3">
//         <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
//           <path d="M20 6L9 17l-5-5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//         </svg>
//         <div>
//           <div className="font-semibold">Message sent</div>
//           <div className="text-sm text-black/70">Thanks! I'll reply soon.</div>
//         </div>
//       </div>
//     </motion.div>
//   );
// }

// function ErrorToast({ onClose }) {
//   useEffect(() => { 
//     const id = setTimeout(onClose, 3000); 
//     return () => clearTimeout(id); 
//   }, [onClose]);
  
//   return (
//     <motion.div 
//       initial={{ opacity: 0, y: 20 }} 
//       animate={{ opacity: 1, y: 0 }} 
//       exit={{ opacity: 0, y: 20 }} 
//       transition={{ duration: 0.4 }} 
//       className="fixed right-6 bottom-6 z-50"
//     >
//       <div className="px-5 py-3 rounded-xl bg-gradient-to-r from-red-500 to-orange-400 text-white shadow-lg flex items-center gap-3">
//         <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
//           <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//         </svg>
//         <div>
//           <div className="font-semibold">Error sending message</div>
//           <div className="text-sm text-white/90">Please try again later</div>
//         </div>
//       </div>
//     </motion.div>
//   );
// }

// function Footer() {
//   const navigationLinks = [
//     { id: 'about', label: 'About' },
//     { id: 'portfolio', label: 'My Portfolio' },
//     { id: 'workbench', label: 'Workbench' },
//     { id: 'figures', label: 'Figures' },
//     { id: 'certifications', label: 'Certifications' },
//     { id: 'contact', label: 'Contact' }
//   ];

//   const socialLinks = [
//     { name: 'GitHub', icon: <GitHubIcon />, url: 'https://github.com/V1VEK-Y4DAV' },
//     { name: 'LinkedIn', icon: <LinkedInIcon />, url: 'https://www.linkedin.com/in/v1vek-y4dav/' },
//     { name: 'Twitter', icon: <TwitterIcon />, url: 'https://x.com/VIVEKxxi' },
//     { name: 'LeetCode', icon: <LeetCodeIcon />, url: 'https://leetcode.com/u/V1VEK_/' }
//   ];

//   const scrollToSection = (sectionId) => {
//     const section = document.getElementById(sectionId);
//     if (section) {
//       window.scrollTo({
//         top: section.offsetTop - 80,
//         behavior: 'smooth'
//       });
//     }
//   };

//   return (
//     <footer className="mt-4 border-t pt-4 pb-4 text-gray-400 bg-gradient-to-b from-gray-900/50 to-black">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           {/* Brand Section */}
//           <div className="md:col-span-1">
//             <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-indigo-500 mb-1">
//               V1VEK-Y4DAV
//             </h2>
//             <p className="text-gray-400 text-sm mb-2">
//               A passionate full-stack developer specializing in creating innovative web solutions with modern technologies. With expertise in React, Node.js, and cloud platforms, I transform complex requirements into elegant, efficient applications. My approach combines technical excellence with creative problem-solving to deliver exceptional digital experiences that drive results.
//             </p>
//           </div>

//           {/* Navigation Links and Social Media */}
//           <div className="md:col-span-1">
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <h3 className="text-lg font-semibold text-white mb-1">Navigation</h3>
//                 <div className="flex flex-col gap-1">
//                   {navigationLinks.map((link, index) => (
//                     <button 
//                       key={index}
//                       onClick={() => scrollToSection(link.id)}
//                       className="text-cyan-300 hover:text-cyan-400 transition-colors duration-300 text-left text-sm"
//                     >
//                       {link.label}
//                     </button>
//                   ))}
//                 </div>
//               </div>
              
//               <div>
//                 <h3 className="text-lg font-semibold text-white mb-1">Connect With Me</h3>
//                 <div className="flex flex-col space-y-1">
//                   {socialLinks.map((social, index) => (
//                     <a 
//                       key={index}
//                       href={social.url} 
//                       target="_blank" 
//                       rel="noreferrer" 
//                       className="flex items-center gap-2 text-gray-400 hover:text-cyan-400 transition-colors duration-300"
//                     >
//                       <span className="w-5 h-5">{social.icon}</span>
//                       <span className="text-sm">{social.name}</span>
//                     </a>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Resume Section */}
//           <div className="md:col-span-1">
//             <h3 className="text-lg font-semibold text-white mb-1">Download</h3>
//             <div className="p-2 rounded-lg bg-gradient-to-br from-gray-800/60 to-gray-900/40 border border-gray-700/60">
//               <div className="flex items-center gap-2 mb-2">
//                 <div className="w-8 h-8 rounded-md flex items-center justify-center bg-gradient-to-br from-cyan-400/10 to-indigo-500/10">
//                   <svg className="w-5 h-5 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16v1a3 3 0 003 3h13A2.5 2.5 0 0021 15.5v-7" />
//                     <path d="M21 7l-9 6L3 7" />
//                   </svg>
//                 </div>
//                 <div>
//                   <div className="font-medium text-white text-sm">My Resume</div>
//                   <div className="text-xs text-gray-400">Updated recently</div>
//                 </div>
//               </div>
//               <a 
//                 href="/pictures/VIVEK KUMAR YADAV.pdf" 
//                 download="VIVEK KUMAR YADAV.pdf"
//                 className="w-full inline-flex items-center justify-center gap-1 rounded-lg py-1 px-2 text-sm font-medium bg-gradient-to-r from-cyan-500 to-indigo-600 text-white hover:opacity-90 transition-opacity duration-300"
//               >
//                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16v1a3 3 0 003 3h13A2.5 2.5 0 0021 15.5v-7" />
//                   <path d="M21 7l-9 6L3 7" />
//                 </svg>
//                 Download
//               </a>
//             </div>
//           </div>
//         </div>

//         <div className="mt-4 pt-3 border-t border-gray-800/60 text-center text-xs text-gray-500">
//           <div className="flex flex-col md:flex-row items-center justify-center gap-2">
//             <div>Built with React + Framer Motion</div>
//             <div className="hidden md:block h-3 w-px bg-gray-700/60" />
//             <div>© {new Date().getFullYear()} Vivek Yadav. All rights reserved.</div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// /* ---------------------------
//    Decorative Icons
//    --------------------------- */
// function MailIcon() {
//   return (
//     <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
//       <path d="M3 8.5v7A2.5 2.5 0 005.5 18h13A2.5 2.5 0 0021 15.5v-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
//       <path d="M21 7l-9 6L3 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
//     </svg>
//   );
// }

// function LocationIcon() {
//   return (
//     <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
//       <path d="M12 21s-7-4.35-7-10a7 7 0 0114 0c0 5.65-7 10-7 10z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
//       <circle cx="12" cy="11" r="2.5" strokeWidth="1.2" />
//     </svg>
//   );
// }



// function GitHubIcon() {
//   return (
//     <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
//       <path d="M9 19c-4.5 1.5-4.5-2-6-2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
//       <path d="M20 12c0 4-2.5 7-7 7-1 0-2-.2-2.9-.6" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
//       <path d="M9 7a3 3 0 116 0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
//     </svg>
//   );
// }

// function LinkedInIcon() {
//   return (
//     <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
//       <rect x="2" y="3" width="20" height="18" rx="2" strokeWidth="1.2" />
//       <path d="M7 10v7" strokeLinecap="round" strokeWidth="1.2" />
//       <path d="M7 7v.01" strokeLinecap="round" strokeWidth="1.2" />
//       <path d="M12 13v4" strokeLinecap="round" strokeWidth="1.2" />
//       <path d="M12 10v.01" strokeLinecap="round" strokeWidth="1.2" />
//     </svg>
//   );
// }

// function TwitterIcon() {
//   return (
//     <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
//       <path d="M23 3a10.9 10.9 0 01-3.14 1.53A4.48 4.48 0 0012 6v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
//     </svg>
//   );
// }

// function LeetCodeIcon() {
//   return (
//     <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
//       <path d="M6 3h12v18H6z" strokeLinecap="round" strokeWidth="1.2" />
//       <path d="M9 8h6" strokeLinecap="round" strokeWidth="1.2" />
//     </svg>
//   );
// }












import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from '@emailjs/browser';

export default function Contact({ onSectionChange }) {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [typingText, setTypingText] = useState('');
  const [typingIndex, setTypingIndex] = useState(0);
  const [typingComplete, setTypingComplete] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [userMessage, setUserMessage] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const formRef = useRef(null);
  const chatContainerRef = useRef(null);
  const canvasRef = useRef(null);

  // Typing animation effect
  useEffect(() => {
    const phrases = [
      "Let's create something amazing together",
      "Ready to bring your ideas to life",
      "Innovative solutions for your needs",
      "Your vision, our expertise"
    ];
    const currentPhrase = phrases[typingIndex];
    
    if (typingText.length < currentPhrase.length) {
      const timeout = setTimeout(() => {
        setTypingText(currentPhrase.substring(0, typingText.length + 1));
      }, 100);
      return () => clearTimeout(timeout);
    } else {
      const timeout = setTimeout(() => {
        if (typingIndex < phrases.length - 1) {
          setTypingIndex(prev => prev + 1);
          setTypingText('');
        } else {
          setTypingComplete(true);
        }
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [typingText, typingIndex]);

  // Canvas particles initialization (with light theme)
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    const particles = [];
    const particleCount = Math.floor(canvas.width / 10);
    
    // Create particles with light theme colors
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 3 + 1,
        color: `rgba(0, 150, 255, ${Math.random() * 0.3 + 0.1})`,
        speed: Math.random() * 0.5 + 0.1,
        angle: Math.random() * Math.PI * 2,
        drift: (Math.random() - 0.5) * 0.05
      });
    }
    
    // Mouse interaction
    let mouseX = 0;
    let mouseY = 0;
    let mouseRadius = 100;
    
    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    
    // Animation loop
    let animationFrameId;
    
    const render = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Draw gradient background (light theme)
      const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
      gradient.addColorStop(0, '#f8fafc');
      gradient.addColorStop(0.5, '#f1f5f9');
      gradient.addColorStop(1, '#e2e8f0');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Update and draw particles
      particles.forEach(p => {
        // Move particle
        p.x += Math.cos(p.angle) * p.speed;
        p.y += Math.sin(p.angle) * p.speed;
        p.angle += p.drift;
        
        // Boundary check
        if (p.x < -p.radius) p.x = canvas.width + p.radius;
        if (p.x > canvas.width + p.radius) p.x = -p.radius;
        if (p.y < -p.radius) p.y = canvas.height + p.radius;
        if (p.y > canvas.height + p.radius) p.y = -p.radius;
        
        // Mouse interaction
        const dx = p.x - mouseX;
        const dy = p.y - mouseY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (distance < mouseRadius) {
          const force = (mouseRadius - distance) / mouseRadius;
          p.x += dx * force * 0.1;
          p.y += dy * force * 0.1;
        }
        
        // Draw particle
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      });
      
      // Connect particles
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          
          if (distance < 100) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(0, 150, 255, ${0.1 * (1 - distance/100)})`;
            ctx.lineWidth = 0.5;
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      }
      
      animationFrameId = requestAnimationFrame(render);
    };
    
    render();
    
    // Cleanup
    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  // Chat auto-scroll
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatMessages]);

  const validators = {
    name: v => v.trim().length >= 2,
    email: v => /^\S+@\S+\.\S+$/.test(v),
    subject: v => v.trim().length >= 3,
    message: v => v.trim().length >= 10
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(s => ({ ...s, [name]: value }));
    setErrors(s => ({ ...s, [name]: validators[name] ? !validators[name](value) : false }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const newErrors = {};
    Object.keys(validators).forEach(k => { 
      if (!validators[k](formData[k] || '')) newErrors[k] = true 
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return;
    setIsSubmitting(true);
    
    try {
      const result = await emailjs.sendForm(
        'service_1i5nx08',
        'template_svdxpun',
        formRef.current, 
        '3V99tek_1xPeoRF7I'
      );
      
      console.log('EmailJS Result:', result);
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setIsSuccess(false), 3200);
    } catch (error) {
      console.error('EmailJS Error:', error);
      setIsSubmitting(false);
      setIsError(true);
      setTimeout(() => setIsError(false), 3200);
    }
  };

  const handleChatSubmit = e => {
    e.preventDefault();
    if (!userMessage.trim()) return;
    
    const newMessages = [...chatMessages, 
      { text: userMessage, sender: 'user', time: new Date() }
    ];
    setChatMessages(newMessages);
    
    const userMsg = userMessage;
    setUserMessage('');
    
    if (userEmail) {
      const templateParams = {
        from_name: 'Vivek Yadav',
        to_email: userEmail,
        message: userMsg,
        auto_reply_message: `Thank you for contacting me! This is an automated response to confirm I have received your message. I will review your inquiry and get back to you within 24 hours.\n\nBest regards,\nVivek Yadav`
      };
      
      emailjs.send(
        'service_1i5nx08',
        'template_40myx8j',
        templateParams,
        '3V99tek_1xPeoRF7I'
      ).then((response) => {
        console.log('Auto-reply sent successfully!', response.status, response.text);
      }).catch((err) => {
        console.error('Failed to send auto-reply:', err);
      });
    }
    
    setTimeout(() => {
      const responses = [
        "Thanks for your message! I've received it and will get back to you within 24 hours.",
        "I've received your inquiry and sent you an automatic confirmation. I'll respond personally soon!",
        "Great question! I've noted your message and sent you an auto-confirmation. I'll get back to you shortly.",
        "I appreciate you reaching out. You should receive an auto-confirmation email, and I'll follow up personally soon."
      ];
      setChatMessages(prev => [
        ...prev, 
        { 
          text: responses[Math.floor(Math.random() * responses.length)], 
          sender: 'bot', 
          time: new Date() 
        }
      ]);
    }, 1500);
  };

  return (
    <div className={`min-h-screen relative overflow-hidden bg-white py-12 px-4 sm:px-6 lg:px-8`}>
      <canvas 
        ref={canvasRef} 
        className="absolute inset-0 w-full h-full -z-10"
      />

      <div className="max-w-7xl mx-auto relative z-20">
        <Header 
          typingText={typingText} 
          typingComplete={typingComplete}
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start mt-12">
          <motion.div 
            className="lg:col-span-7" 
            initial={{ opacity: 0, x: -40 }} 
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.8, delay: 0.15 }}
          >
            <ContactCardForm
              formRef={formRef}
              formData={formData}
              onChange={handleInputChange}
              onSubmit={handleSubmit}
              errors={errors}
              isSubmitting={isSubmitting}
              setFormData={setFormData}
              setErrors={setErrors}
            />

            <Testimonials />

          </motion.div>

          <motion.aside 
            className="lg:col-span-5 space-y-6" 
            initial={{ opacity: 0, x: 40 }} 
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.8, delay: 0.25 }}
          >
            <ContactInfoPanel />
            <QuickMap />
          </motion.aside>
        </div>

        <div className="mt-8 flex items-center justify-center">
          <motion.button 
            onClick={() => {
              const section = document.getElementById('about');
              if (section) {
                window.scrollTo({
                  top: section.offsetTop - 80,
                  behavior: 'smooth'
                });
              }
            }} 
            whileHover={{ scale: 1.04 }} 
            whileTap={{ scale: 0.96 }} 
            className="px-8 py-3 rounded-full font-semibold shadow-xl bg-gradient-to-r from-cyan-500 to-blue-600 text-white"
          >
            Back to Home
          </motion.button>
        </div>

      </div>

      <AnimatePresence>
        {isSuccess && <SuccessToast onClose={() => setIsSuccess(false)} />}
        {isError && <ErrorToast onClose={() => setIsError(false)} />}
      </AnimatePresence>
      
      <LiveChatWidget 
        isOpen={isChatOpen} 
        setIsOpen={setIsChatOpen}
        messages={chatMessages}
        userMessage={userMessage}
        setUserMessage={setUserMessage}
        onSubmit={handleChatSubmit}
        chatContainerRef={chatContainerRef}
        userEmail={userEmail}
        setUserEmail={setUserEmail}
        showEmailInput={showEmailInput}
        setShowEmailInput={setShowEmailInput}
      />

      <Footer />
    </div>
  );
}

/* ---------------------------
   Header with typing effect
   --------------------------- */
function Header({ typingText, typingComplete }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.8 }} 
      className="text-center mb-12"
    >
      <h1 className="text-5xl sm:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 via-blue-600 to-indigo-700">
        Get In Touch
      </h1>
      
      <div className="mt-4 h-16 flex items-center justify-center">
        {typingComplete ? (
          <motion.p 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            className="text-lg max-w-3xl mx-auto text-gray-600"
          >
            Ready to collaborate? Tell me about your project and I'll get back to you.
          </motion.p>
        ) : (
          <p className="text-lg max-w-3xl mx-auto h-6 text-gray-600">
            {typingText}
            <motion.span 
              animate={{ opacity: [0, 1, 0] }} 
              transition={{ repeat: Infinity, duration: 1 }} 
              className="ml-1 text-cyan-500"
            >
              |
            </motion.span>
          </p>
        )}
      </div>
    </motion.div>
  );
}

/* ---------------------------
   Contact Form Card (Light Theme)
   --------------------------- */
function ContactCardForm({ formRef, formData, onChange, onSubmit, errors, isSubmitting, setFormData, setErrors }) {
  return (
    <div className="p-8 rounded-2xl bg-gradient-to-br from-white to-cyan-50/30 shadow-lg border-2 border-cyan-100 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-cyan-200/30 to-transparent rounded-bl-full"></div>
      <h2 className="text-2xl font-bold mb-6 text-gray-900 relative z-10">Send a message</h2>

      <form ref={formRef} onSubmit={onSubmit} className="space-y-6 relative z-10">
        <FloatingInput 
          name="name" 
          value={formData.name} 
          onChange={onChange} 
          placeholder="Name" 
          error={errors.name}
        />
        <FloatingInput 
          name="email" 
          type="email" 
          value={formData.email} 
          onChange={onChange} 
          placeholder="Email" 
          error={errors.email}
        />
        <FloatingInput 
          name="subject" 
          value={formData.subject} 
          onChange={onChange} 
          placeholder="Subject" 
          error={errors.subject}
        />
        <FloatingTextarea 
          name="message" 
          value={formData.message} 
          onChange={onChange} 
          placeholder="Your message" 
          error={errors.message}
        />

        <div className="flex items-center gap-4">
          <motion.button 
            whileHover={{ scale: 1.02 }} 
            whileTap={{ scale: 0.98 }} 
            type="submit" 
            disabled={isSubmitting} 
            className="flex-1 inline-flex items-center justify-center gap-3 rounded-lg py-3 px-5 font-semibold shadow-lg hover:brightness-110 transition-all bg-gradient-to-r from-cyan-500 to-blue-600 text-white"
          >
            {isSubmitting ? <Spinner /> : <SendIcon />}
            <span>{isSubmitting ? 'Sending...' : 'Send Message'}</span>
          </motion.button>

          <motion.button 
            whileHover={{ scale: 1.02 }} 
            whileTap={{ scale: 0.98 }} 
            type="button" 
            onClick={() => { setFormData({ name: '', email: '', subject: '', message: '' }); setErrors({}); }} 
            className="px-4 py-3 rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
          >
            Reset
          </motion.button>
        </div>
      </form>
    </div>
  );
}

/* ---------------------------
   Live Chat Widget (Light Theme)
   --------------------------- */
function LiveChatWidget({ isOpen, setIsOpen, messages, userMessage, setUserMessage, onSubmit, chatContainerRef, userEmail, setUserEmail, showEmailInput, setShowEmailInput }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          className="fixed bottom-24 right-6 z-50 w-full max-w-md rounded-2xl shadow-xl overflow-hidden bg-white border border-gray-200"
        >
          <div className="p-4 flex justify-between items-center bg-gradient-to-r from-cyan-500 to-blue-600">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <div className="font-semibold text-white">Support Team</div>
                <div className="text-xs text-cyan-100">Online now</div>
              </div>
            </div>
            <button 
              onClick={() => setIsOpen(false)}
              className="text-white/80 hover:text-white"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div 
            ref={chatContainerRef}
            className="h-80 overflow-y-auto p-4 space-y-4 bg-gray-50"
          >
            {messages.length === 0 ? (
              <div className="h-full flex flex-col items-center justify-center text-center p-4">
                <div className="mb-4">
                  <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-r from-cyan-500 to-blue-600 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                  </div>
                </div>
                <h3 className="font-bold text-lg mb-2 text-gray-900">How can we help you?</h3>
                <p className="text-gray-500">Send us a message and we'll get back to you as soon as possible.</p>
              </div>
            ) : (
              messages.map((msg, index) => (
                <div 
                  key={index} 
                  className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
                >
                  <div 
                    className={`max-w-xs rounded-2xl px-4 py-2 ${msg.sender === 'user' 
                      ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white' 
                      : 'bg-gray-200 text-gray-900'}`}
                  >
                    {msg.text}
                    <div className={`text-xs mt-1 ${msg.sender === 'user' ? 'text-cyan-100' : 'text-gray-500'}`}>
                      {msg.time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          
          <form onSubmit={onSubmit} className="p-3 border-t border-gray-200 bg-white">
            {showEmailInput && (
              <div className="mb-2">
                <input
                  type="email"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  placeholder="Your email for auto-reply..."
                  className="w-full rounded-full px-4 py-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
                />
              </div>
            )}
            <div className="flex gap-2">
              <input
                type="text"
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
                placeholder="Type your message..."
                className="flex-1 rounded-full px-4 py-2 bg-gray-50 border border-gray-300 text-gray-900 focus:outline-none focus:ring-2 focus:ring-cyan-500"
              />
              <button 
                type="submit"
                className="w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-90"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                </svg>
              </button>
            </div>
            {!showEmailInput && (
              <div className="mt-2 text-right">
                <button
                  type="button"
                  onClick={() => setShowEmailInput(true)}
                  className="text-xs text-cyan-600 hover:text-cyan-700"
                >
                  Add email for auto-reply
                </button>
              </div>
            )}
          </form>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

/* ---------------------------
   Form inputs (Floating) - Light Theme
   --------------------------- */
function FloatingInput({ name, value, onChange, placeholder, error, type = 'text' }) {
  return (
    <div className={`relative`}> 
      <input 
        name={name} 
        type={type} 
        value={value} 
        onChange={onChange} 
        placeholder={placeholder} 
        className={`peer w-full rounded-xl px-4 py-3 focus:outline-none focus:ring-2 transition ${
          `bg-white border ${error ? 'border-red-400' : 'border-gray-300'} text-gray-900 placeholder-transparent focus:ring-cyan-500 focus:border-cyan-500`}`} 
      />
      <label className={`absolute left-4 top-2 text-sm transition-all pointer-events-none text-gray-500 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:text-sm peer-focus:top-2 peer-focus:text-cyan-600 ${value ? 'hidden' : 'block'}`}
      >
        {placeholder}
      </label>
      <div className={`mt-2 text-xs ${error ? 'text-red-500' : 'text-gray-400'}`}>
        {error ? 'Please provide a valid value' : '\u00A0'}
      </div>
    </div>
  );
}

function FloatingTextarea({ name, value, onChange, placeholder, error }) {
  return (
    <div className="relative"> 
      <textarea 
        name={name} 
        value={value} 
        onChange={onChange} 
        placeholder={placeholder} 
        rows={6} 
        className={`peer w-full rounded-xl px-4 py-3 focus:outline-none focus:ring-2 transition resize-none ${
          `bg-white border ${error ? 'border-red-400' : 'border-gray-300'} text-gray-900 placeholder-transparent focus:ring-cyan-500 focus:border-cyan-500`}`} 
      />
      <label className={`absolute left-4 top-2 text-sm transition-all pointer-events-none text-gray-500 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:text-sm peer-focus:top-2 peer-focus:text-cyan-600 ${value ? 'hidden' : 'block'}`}
      >
        {placeholder}
      </label>
      <div className={`mt-2 text-xs ${error ? 'text-red-500' : 'text-gray-400'}`}>
        {error ? 'Message must be at least 10 characters' : '\u00A0'}
      </div>
    </div>
  );
}

/* ---------------------------
   Spinner & Icons
   --------------------------- */
function Spinner() {
  return (
    <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.2)" strokeWidth="4" />
      <path d="M4 12a8 8 0 018-8" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

function SendIcon() {
  return (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
      <path d="M2 21l21-9L2 3v7l15 2-15 2v7z" fill="white" />
    </svg>
  );
}

/* ---------------------------
   Testimonials - Light Theme
   --------------------------- */
function Testimonials() {
  const data = [
    { name: 'Raman', role: 'Student', quote: 'Every scroll feels intentional. Every click feels rewarding.' },
    { name: 'Simarpreet', role: 'Frontend Developer', quote: 'Clean UI — this site is basically a React symphony.' },
    { name: 'Nikhil', role: 'ML&AI Engineer', quote: 'Bro that Animation... Wow! I love it!' },
    { name: 'San', role: 'Engineer', quote: 'Definitely the best website I have ever encountered.' }
  ];
  
  return (
    <div className="mt-6 space-y-4">
      <h3 className="font-semibold mb-2 text-gray-900">What people say</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {data.map((t, i) => (
          <motion.div 
            key={i} 
            initial={{ opacity: 0, y: 10 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ delay: 0.1 + i * 0.08 }} 
            className="p-4 rounded-lg bg-gray-50 border border-gray-200"
          >
            <div className="text-gray-700">"{t.quote}"</div>
            <div className="mt-3 text-sm text-gray-500">
              — {t.name}, <span className="text-gray-600">{t.role}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

/* ---------------------------
   Contact info panel - Light Theme
   --------------------------- */
function ContactInfoPanel() {
  return (
    <div className="p-6 rounded-2xl bg-gradient-to-br from-white to-purple-50/30 shadow-lg border-2 border-purple-100 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-purple-200/30 to-transparent rounded-bl-full"></div>
      <h2 className="text-2xl font-bold mb-4 text-gray-900 relative z-10">Contact Info</h2>

      <div className="space-y-4 relative z-10">
        <ContactCard 
          title="Email" 
          subtitle="vivekkuyadav21@gmail.com" 
          icon={<MailIcon />}
        />
        <ContactCard 
          title="Location" 
          subtitle="Lovely Professional University (LPU), Jalandhar-Delhi G.T. Road, Phagwara, Punjab, India - 144411" 
          icon={<LocationIcon />}
        />
      </div>

      <div className="mt-6">
        <h3 className="font-semibold mb-3 text-gray-900">Connect</h3>
        <SocialGrid />
      </div>
    </div>
  );
}

/* ---------------------------
   Quick Map - Light Theme
   --------------------------- */
function QuickMap() {
  return (
    <div className="p-6 rounded-2xl bg-gradient-to-br from-white to-blue-50/30 shadow-lg border-2 border-blue-100 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-blue-200/30 to-transparent rounded-bl-full"></div>
      <h3 className="font-semibold mb-3 text-gray-900 relative z-10">Quick Map</h3>
      <div className="w-full h-44 rounded-lg overflow-hidden border-2 border-gray-200 relative z-10">
        <iframe 
          title="map" 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3423.297054450433!2d75.70487037532045!3d31.25417987433384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5a5b2bdb287d%3A0x6890235e8d1dc490!2sLovely%20Professional%20University!5e0!3m2!1sen!2sin!4v1691760000000" 
          className="w-full h-full" 
          loading="lazy"
        ></iframe>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3">
        <MiniStat label="Avg response" value="1-2 days" />
        <MiniStat label="Projects" value="30+" />
        <MiniStat label="Experience" value="5 yrs" />
        <MiniStat label="Availability" value="Part-time" />
      </div>
    </div>
  );
}

/* ---------------------------
   Mini stat & funfact - Light Theme
   --------------------------- */
function MiniStat({ label, value }) {
  return (
    <div className="p-3 rounded-lg text-center bg-gradient-to-br from-white to-gray-50 border-2 border-gray-200 shadow-sm">
      <div className="text-sm text-gray-500">{label}</div>
      <div className="text-lg font-semibold text-gray-900">{value}</div>
    </div>
  );
}

/* ---------------------------
   Contact card small - Light Theme
   --------------------------- */
function ContactCard({ title, subtitle, icon }) {
  return (
    <div className="flex items-center gap-3 p-3 rounded-lg bg-gradient-to-br from-white to-cyan-50 border-2 border-cyan-100 hover:border-cyan-200 transition-colors shadow-sm">
      <div className="w-12 h-12 rounded-md flex items-center justify-center bg-gradient-to-br from-cyan-100 to-blue-100">
        {icon}
      </div>
      <div>
        <div className="text-sm font-medium text-gray-700">{title}</div>
        <div className="text-sm text-gray-500">{subtitle}</div>
      </div>
    </div>
  );
}

/* ---------------------------
   Social grid - Light Theme
   --------------------------- */
function SocialGrid() {
  const socials = [
    { name: 'GitHub', icon: <GitHubIcon />, url: 'https://github.com/V1VEK-Y4DAV' },
    { name: 'LinkedIn', icon: <LinkedInIcon />, url: 'https://www.linkedin.com/in/v1vek-y4dav/' },
    { name: 'Twitter', icon: <TwitterIcon />, url: 'https://x.com/VIVEKxxi' },
    { name: 'LeetCode', icon: <LeetCodeIcon />, url: 'https://leetcode.com/u/V1VEK_/' }
  ];
  
  return (
    <div className="grid grid-cols-2 gap-3">
      {socials.map((s, i) => (
        <motion.a 
          key={s.name} 
          href={s.url} 
          target="_blank" 
          rel="noreferrer" 
          whileHover={{ y: -4 }} 
          className="flex items-center gap-3 p-3 rounded-lg bg-gray-50 border border-gray-200 hover:bg-gray-100 hover:border-cyan-300 transition-all duration-300 shadow-sm hover:shadow-md"
        >
          <div className="w-8 h-8 rounded-md flex items-center justify-center bg-white">
            {s.icon}
          </div>
          <div className="text-sm font-medium text-gray-700">
            {s.name}
          </div>
        </motion.a>
      ))}
    </div>
  );
}

/* ---------------------------
   Footer and Success toast - Light Theme
   --------------------------- */
function SuccessToast({ onClose }) {
  useEffect(() => { const id = setTimeout(onClose, 3000); return () => clearTimeout(id); }, [onClose]);
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      exit={{ opacity: 0, y: 20 }} 
      transition={{ duration: 0.4 }} 
      className="fixed right-6 bottom-6 z-50"
    >
      <div className="px-5 py-3 rounded-xl bg-gradient-to-r from-green-500 to-emerald-400 text-white shadow-lg flex items-center gap-3">
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
          <path d="M20 6L9 17l-5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <div>
          <div className="font-semibold">Message sent</div>
          <div className="text-sm text-white/90">Thanks! I'll reply soon.</div>
        </div>
      </div>
    </motion.div>
  );
}

function ErrorToast({ onClose }) {
  useEffect(() => { 
    const id = setTimeout(onClose, 3000); 
    return () => clearTimeout(id); 
  }, [onClose]);
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      exit={{ opacity: 0, y: 20 }} 
      transition={{ duration: 0.4 }} 
      className="fixed right-6 bottom-6 z-50"
    >
      <div className="px-5 py-3 rounded-xl bg-gradient-to-r from-red-500 to-orange-400 text-white shadow-lg flex items-center gap-3">
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <div>
          <div className="font-semibold">Error sending message</div>
          <div className="text-sm text-white/90">Please try again later</div>
        </div>
      </div>
    </motion.div>
  );
}

function Footer() {
  const navigationLinks = [
    { id: 'about', label: 'About' },
    { id: 'portfolio', label: 'My Portfolio' },
    { id: 'workbench', label: 'Workbench' },
    { id: 'figures', label: 'Figures' },
    { id: 'certifications', label: 'Certifications' },
    { id: 'contact', label: 'Contact' }
  ];

  const socialLinks = [
    { name: 'GitHub', icon: <GitHubIcon />, url: 'https://github.com/V1VEK-Y4DAV' },
    { name: 'LinkedIn', icon: <LinkedInIcon />, url: 'https://www.linkedin.com/in/v1vek-y4dav/' },
    { name: 'Twitter', icon: <TwitterIcon />, url: 'https://x.com/VIVEKxxi' },
    { name: 'LeetCode', icon: <LeetCodeIcon />, url: 'https://leetcode.com/u/V1VEK_/' }
  ];

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="mt-4 border-t pt-4 pb-4 text-gray-600 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-500 to-blue-600 mb-1">
              V1VEK-Y4DAV
            </h2>
            <p className="text-gray-500 text-sm mb-2">
              A passionate full-stack developer specializing in creating innovative web solutions with modern technologies. With expertise in React, Node.js, and cloud platforms, I transform complex requirements into elegant, efficient applications. My approach combines technical excellence with creative problem-solving to deliver exceptional digital experiences that drive results.
            </p>
          </div>

          {/* Navigation Links and Social Media */}
          <div className="md:col-span-1">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">Navigation</h3>
                <div className="flex flex-col gap-1">
                  {navigationLinks.map((link, index) => (
                    <button 
                      key={index}
                      onClick={() => scrollToSection(link.id)}
                      className="text-cyan-600 hover:text-cyan-700 transition-colors duration-300 text-left text-sm"
                    >
                      {link.label}
                    </button>
                  ))}
                </div>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">Connect With Me</h3>
                <div className="flex flex-col space-y-1">
                  {socialLinks.map((social, index) => (
                    <a 
                      key={index}
                      href={social.url} 
                      target="_blank" 
                      rel="noreferrer" 
                      className="flex items-center gap-2 text-gray-500 hover:text-cyan-600 transition-colors duration-300"
                    >
                      <span className="w-5 h-5">{social.icon}</span>
                      <span className="text-sm">{social.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Resume Section */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Download</h3>
            <div className="p-2 rounded-lg bg-gray-50 border border-gray-200">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-md flex items-center justify-center bg-gradient-to-br from-cyan-100 to-blue-100">
                  <svg className="w-5 h-5 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16v1a3 3 0 003 3h13A2.5 2.5 0 0021 15.5v-7" />
                    <path d="M21 7l-9 6L3 7" />
                  </svg>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm">My Resume</div>
                  <div className="text-xs text-gray-500">Updated recently</div>
                </div>
              </div>
              <a 
                href="/pictures/VIVEK KUMAR YADAV.pdf" 
                download="VIVEK KUMAR YADAV.pdf"
                className="w-full inline-flex items-center justify-center gap-1 rounded-lg py-1 px-2 text-sm font-medium bg-gradient-to-r from-cyan-500 to-blue-600 text-white hover:opacity-90 transition-opacity duration-300"
              >
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16v1a3 3 0 003 3h13A2.5 2.5 0 0021 15.5v-7" />
                  <path d="M21 7l-9 6L3 7" />
                </svg>
                Download
              </a>
            </div>
          </div>
        </div>

        <div className="mt-4 pt-3 border-t border-gray-200 text-center text-xs text-gray-500">
          <div className="flex flex-col md:flex-row items-center justify-center gap-2">
            <div>Built with React + Framer Motion</div>
            <div className="hidden md:block h-3 w-px bg-gray-300" />
            <div>© {new Date().getFullYear()} Vivek Yadav. All rights reserved.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ---------------------------
   Decorative Icons - Light Theme
   --------------------------- */
function MailIcon() {
  return (
    <svg className="w-6 h-6 text-cyan-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M3 8.5v7A2.5 2.5 0 005.5 18h13A2.5 2.5 0 0021 15.5v-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M21 7l-9 6L3 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg className="w-6 h-6 text-cyan-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M12 21s-7-4.35-7-10a7 7 0 0114 0c0 5.65-7 10-7 10z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
      <circle cx="12" cy="11" r="2.5" strokeWidth="1.2" />
    </svg>
  );
}

function GitHubIcon() {
  return (
    <svg className="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M9 19c-4.5 1.5-4.5-2-6-2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
      <path d="M20 12c0 4-2.5 7-7 7-1 0-2-.2-2.9-.6" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
      <path d="M9 7a3 3 0 116 0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg className="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="2" y="3" width="20" height="18" rx="2" strokeWidth="1.2" />
      <path d="M7 10v7" strokeLinecap="round" strokeWidth="1.2" />
      <path d="M7 7v.01" strokeLinecap="round" strokeWidth="1.2" />
      <path d="M12 13v4" strokeLinecap="round" strokeWidth="1.2" />
      <path d="M12 10v.01" strokeLinecap="round" strokeWidth="1.2" />
    </svg>
  );
}

function TwitterIcon() {
  return (
    <svg className="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M23 3a10.9 10.9 0 01-3.14 1.53A4.48 4.48 0 0012 6v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
    </svg>
  );
}

function LeetCodeIcon() {
  return (
    <svg className="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M6 3h12v18H6z" strokeLinecap="round" strokeWidth="1.2" />
      <path d="M9 8h6" strokeLinecap="round" strokeWidth="1.2" />
    </svg>
  );
}